import * as React from 'react'
import styled, { css } from 'styled-components'
import media from '../../../../services/generateMediaQueries'

// MainView styled components
export const MainContainer = styled.div`
  position: relative;
  z-index: 0;
  overflow: hidden;
`

export const HeroSection = styled.div`
  position: relative;
  max-height: 80vh;
  z-index: 0;
`

export const BackgroundVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -2;
  pointer-events: none;
`
// TODO: Remove if not needed anymore
/* export const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(60, 5, 55, 0.81);
  z-index: -1;
  pointer-events: none;
` */

export const HeroContent = styled.div`
  z-index: 1;
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 2% 0;
  gap: 2.5rem;
`

export const HeroLogoArea = styled.div`
  flex: 1 1 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 0;
`

export const LogoContainer = styled.div`
  gap: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 70px;
`

export const SpaceLogo = styled.img`
  height: 100px;

  @media (max-width: 992px) {
    height: 60px;
  }
`

export const TaglineLogo = styled.img`
  height: 250px;
  margin-top: 130px;
  margin-bottom: 50px;

  @media (max-width: 992px) {
    height: 150px;
    margin-top: 50px;
    margin-bottom: 20px;
  }
`

export const ButtonContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 30px;

  @media (max-width: 992px) {
    flex-direction: column;
    align-self: center;
    gap: 15px;
  }
`

export const PrimaryButton = styled.button`
  height: 65px;
  width: 230px;
  border-radius: 10px;
  color: #480b69;
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.08em;
  font-size: 1.2rem;
  cursor: pointer;
  border: none;
  background: white;
`

export const SecondaryButton = styled.button`
  height: 65px;
  width: 230px;
  border-radius: 10px;
  color: white;
  background: rgba(173, 86, 197, 0.31);
  border: none;
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.08em;
  font-size: 1.2rem;
  cursor: pointer;
`

export const AboutSection = styled.div`
  position: relative;
  min-height: 100vh;
  background-color: black;
  background-image: url(${props => props.bgImage || 'none'});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  display: flex;
  align-items: start;
  justify-content: center;
  gap: 30px;
  padding: 30px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: -1;
    pointer-events: none;
  }

  @media (max-width: 992px) {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
    padding: 20px;
  }
`

export const ImageGrid = styled.div`
  width: 50%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-areas:
    'space1 space2'
    'space1 space4'
    'space3 space4';
  gap: 50px;
  padding: 20px;

  @media (max-width: 992px) {
    width: 100%;
    gap: 20px;
    padding: 10px;
  }
`

export const GridImage = styled.img`
  width: 100%;
  height: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  grid-area: ${props => props.gridArea};
`

export const ContentSection = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-evenly;
  padding: 0 2.5rem;

  @media (max-width: 992px) {
    width: 100%;
    min-height: 100vh;
    gap: 20px;
    padding: 10px;
  }
`

export const TriangleLogo = styled.img`
  height: 100px;

  @media (max-width: 992px) {
    height: 50px;
  }
`

export const TitleTaglineContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

export const MainTitle = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  color: white;
  font-size: 3.5rem;
  font-weight: 800;
  margin: 0;

  @media (max-width: 992px) {
    font-size: 2.5rem;
  }
`

export const Description = styled.h3`
  color: white;
  font-size: 1.2rem;
  font-weight: 400;
  margin: 0 0 50px 0;

  @media (max-width: 992px) {
    font-size: 1rem;
  }
`

export const BoldText = styled.span`
  font-weight: 800;
  color: white;
`

export const SubTitleText = styled.h2`
  font-weight: 800;
  margin: 0;
`

export const StatsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 40px;
  background-color: white;
  border-radius: 15px;
  width: 100%;
  max-width: 522px;
  min-height: 135px;
  font-size: 1.7rem;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 992px) {
    width: 100%;
    gap: 20px;
    padding: 20px;
    font-size: 1rem;
  }
`

export const StatsInfo = styled.div`
  display: flex;
  flex-direction: column;
  color: black;

  @media (max-width: 992px) {
    text-align: left;
  }
`

export const StatsNumber = styled.span`
  font-size: 24px;
  font-weight: 500;
  color: black;
  @media (max-width: 992px) {
    font-size: 22px;
  }
`

export const StatsMeasurements = styled.span`
  font-size: 14px;

  @media (min-width: 768px) and (max-width: 992px) {
    white-space: nowrap;
  }
`

export const ViewFloorPlanButton = styled.button`
  padding: 20px;
  border-radius: 10px;
  border: none;
  background-color: #fe3d01;
  color: white;
  font-size: 1.2rem;
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.08em;
  min-height: 65px;
  cursor: pointer;

  @media (max-width: 992px) {
    font-size: 1rem;
    min-height: 50px;
    width: 150px;
    padding: 10px;
  }
`

export const FeaturesContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  font-size: 1.5rem;
  align-items: center;
  justify-content: space-evenly;

  @media (max-width: 992px) {
    width: 100%;
    max-width: 522px;
    font-size: 1rem;
    flex-wrap: wrap;
    row-gap: 1rem;
    justify-content: center;
  }
`

export const FeatureItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  color: white;

  @media (max-width: 992px) {
    flex: 1 1 calc(50% - 12px);
    max-width: calc(50% - 12px);
    min-width: 0;
    box-sizing: border-box;
  }
`

export const FeatureNumber = styled.span`
  font-size: 3.7rem;
  font-weight: 500;

  @media (max-width: 992px) {
    font-size: 2rem;
  }
`

export const FeatureText = styled.span`
  font-family: var(--font-family-ayala-display-sans);
  line-height: 1.2;

  @media (max-width: 992px) {
    font-size: 1rem;
  }
`

export const Divider = styled.div`
  border: 1px solid white;
  height: 4rem;
  flex-shrink: 0;

  @media (max-width: 992px) {
    flex: 0 0 1px;
    align-self: stretch;
    height: auto;
    min-height: 50px;
    border-left: 1px solid white;
    border-top: none;
    border-right: none;
    border-bottom: none;

    ${props =>
      props.$hideOnMobile &&
      css`
        display: none;
      `}
  }
`

// Modal styled components
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`

export const ModalContent = styled.div`
  background-color: white;
  border-radius: 15px;
  width: 90%;
  max-width: 100%;
  max-height: 100%;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;

  @keyframes modalSlideIn {
    from {
      opacity: 0;
      transform: translateY(-50px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid #e0e0e0;
`

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.8rem;
  font-weight: 600;
  color: #333;
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f0f0f0;
    color: #333;
  }
`

export const ModalBody = styled.div`
  padding: 30px;
  color: #555;
  line-height: 1.6;
  height: 80vh;
  position: relative;

  p {
    margin: 0 0 15px 0;
    font-size: 1.1rem;
  }

  p:last-child {
    margin-bottom: 0;
  }
`

export const ControlsContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
`

export const ControlButton = styled.button`
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 6px;
  background: #fe3d01;
  color: white;
  font-size: 18px;
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.08em;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background: #e03501;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`

export const ViewStatsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;

  @media (max-width: 992px) {
    flex-direction: column;
    width: 80%;
    margin: 0 auto;
    align-items: stretch;
    justify-content: center;
    gap: 20px;
  }
`
export const SpaceDescriptionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`

export const DescriptionRow = styled.div`
  display: flex;
  flex-direction: row;
  color: white;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  @media (max-width: 992px) {
    flex-direction: column;
    align-items: center;
  }
`

export const DescriptionCard = styled.div`
  width: 528px;
  height: 288px;
  background-color: ${props =>
    props.variant === 'purple' ? '#44076680' : '#FFFFFF14'};
  padding: 32px;
  border-radius: 16px;
  gap: 26px;
  display: flex;
  flex-direction: column;

  @media (max-width: 992px) {
    width: 100%;
    max-width: 528px;
    height: auto;
    min-height: 288px;
  }
`

export const DescriptionCardTitle = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  color: white;
`

export const DescriptionCardText = styled.span`
  font-size: 18px;
  color: white;
`

export const FinalTitle = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  font-size: 28px;
  margin-top: 50px;
  margin-bottom: 0;
  text-align: center;
  display: block;
  width: 100%;
  color: white;
`

export const SocialFollowSection = styled.div`
  width: 100%;
  margin-top: 20px;
  padding: 32px 24px 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
`

export const SocialFollowHeading = styled.p`
  margin: 0;
  font-family: var(--font-family-ayala-display-sans);
  font-size: 24px;
  font-weight: 500;
  color: #fff;
  text-align: center;
`

export const SocialIconsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
`

export const SocialIconLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  border-radius: 50%;
  transition: transform 0.2s ease, opacity 0.2s ease;

  &:hover {
    transform: scale(1.06);
    opacity: 0.92;
  }

  &:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 4px;
  }
`

export const SocialIconImg = styled.img`
  width: 56px;
  height: 56px;
  display: block;
  object-fit: contain;
`

export const HighlightedText = styled.span`
  color: #ff3f00;
`

// Carousel styled components
export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 50px auto;
  overflow: visible;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);

  @media (max-width: 992px) {
    margin: 30px auto;
  }
`

export const CarouselTrack = styled.div`
  display: flex;
  transition: ${props =>
    props.isTransitioning ? 'transform 0.5s ease-in-out' : 'none'};
  transform: translateX(${props => -props.currentSlide * 50}%);
  width: 200%;

  @media (max-width: 992px) {
    width: ${props => (props.slideCount || 4) * 100}%;
    transform: translateX(${props => -props.currentSlide * 100}%);
  }
`

export const CarouselSlide = styled.div`
  display: flex;
  flex-direction: row;
  min-width: 50%;
  width: 50%;
  height: 320px;
  position: relative;
  flex-shrink: 0;
  opacity: ${props => (props.isActive ? 1 : 0.3)};
  transition: opacity 0.5s ease-in-out;

  @media (max-width: 992px) {
    min-width: 100%;
    width: 100%;
  }
`

export const CarouselImage = styled.img`
  width: 50%;
  height: 320px;
  object-fit: cover;
  display: block;

  @media (max-width: 992px) {
    width: ${props => (props.hideOnMobile ? '0' : '25%')};
    display: ${props => (props.hideOnMobile ? 'none' : 'block')};
  }
`

export const CarouselArrow = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.8);
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #480b69;
  z-index: 10;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  line-height: 1;
  padding: 0;
  margin: 0;

  &:hover {
    background: rgba(255, 255, 255, 1);
    transform: translateY(-50%) scale(1.1);
  }

  &:active {
    transform: translateY(-50%) scale(0.95);
  }

  ${props =>
    props.direction === 'left' &&
    css`
      left: 20px;
    `}

  ${props =>
    props.direction === 'right' &&
    css`
      right: 20px;
    `}

  @media (max-width: 992px) {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
`
